import { connect } from 'react-redux'

import BondDetailView from '../components/BondDetailView'
import { RootState } from '../types/index'
import { CloseBondDetails, closeBondDetails } from '../actions/bondActions'
import { Dispatch } from 'redux'

export function mapStateToProps(rootState: RootState) {
  return {
    positionsPaneOpened: rootState.appState.positionsOpened,
    selectedBond: rootState.bondListState.selectedBond,
    locale: rootState.appConfig.locale
      ? rootState.appConfig.locale
      : rootState.tradingAccounts.viewer.locale,
    mode: rootState.appConfig.mode,
    demo: rootState.appConfig.demo,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<CloseBondDetails>) {
  return {
    onCloseBondDetails: () => dispatch(closeBondDetails()),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BondDetailView)
